<template>
  <v-row>
    <v-btn right top icon x-large absolute class="mr-7" @click="revealAnswer = !revealAnswer">
      <v-icon class="custom-icon" v-if="revealAnswer">$vuetify.icons.appVisible</v-icon>
      <v-icon class="custom-icon" v-else>$vuetify.icons.appInvisible</v-icon>
    </v-btn>
    <v-col cols="12" md="6">
      <textarea
        :value="value"
        @input="$emit('input', $event.target.value)"
        :placeholder="`Write your answer here ${placeholder}`"
        :readonly="readonly"
        auto-grow
        :class="!value ? 'font-italic font-weight-light body-2' : 'body-2'"
        style="height: 60vh; width: 100%; background-color: #f8fcffc0"
      ></textarea>
    </v-col>
    <v-col cols="12" md="6">
      <v-sheet color="#F8FCFFC0" min-height="60vh" class="px-3 pt-4">
        <app-editor v-show="revealAnswer && finished" :value="teacher" :editable="false" />
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
import Editor from "@/components/Utils/Editor.vue";

export default {
  components: {
    appEditor: Editor,
  },
  props: {
    teacher: {
      required: false,
    },
    placeholder: {
      required: false,
      default: "(optional)",
      type: String,
    },
    value: {
      required: false,
      type: String,
      default: "",
    },
    finished: {
      default: true,
      type: Boolean,
    },
    readonly: Boolean,
  },
  data() {
    return {
      revealAnswer: true,
      student: "",
    };
  },
};
</script>
<style scoped>
.color-f9fbff {
  background-color: #f9fbff !important;
  border-radius: 0px !important;
}
.v-textarea {
  height: 30vh !important;
  overflow: auto;
}
</style>
